module.exports = __webpack_public_path__ + "img/_002.08d038a6.png";